<template>
    <div>
      <b-card no-body>
          <b-tabs pills card>
              <b-tab :title="$t('Main')">
                <b-form-group label-align="right" :label="$t('Parent service')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isTariffs || isTariffPlan">
                  <b-form-input type="text" disabled v-model="hotspotService.service_data.parent_id"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="serviceName" aria-describedby="inputFeedbackName" :state="validationName"/>
                  <b-form-invalid-feedback id="inputFeedbackName">
                    {{ $t('Enter title') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="text" v-model="hotspotService.service_data.comment"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Supplier to invoice')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="suppliertList" v-model="selectSupplier"/>
                </b-form-group>
                <b-form-group v-if="isTemplates || isTariffs || isTariffPlan">
                  <b-form-checkbox v-model="linkByDefault">{{ $t('Attach by default') }}</b-form-checkbox>
                  <b-form-checkbox v-model="multipleLinking">{{ $t('Allow multiple linking') }}</b-form-checkbox>
                </b-form-group>
              </b-tab>
              <b-tab :title="$t('Service parameters')">
                <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="serviseCost" aria-describedby="inputFeedbackCost" :state="validationCost"/>
                  <b-form-invalid-feedback id="inputFeedbackCost">
                    {{ $t('Enter cost') }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Charge method')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="chargeMethodList" v-model="selectChargeMethod"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="policyList" v-model="selectPolicy"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Contract type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-select :options="contractList" v-model="selectContract">
                    <template slot="first">
                      <option :value=0></option>
                    </template>
                  </b-form-select>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Limit of simultaneous sessions')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-input type="number" v-model="hotspotService.periodic_service_data.radius_sessions_limit"/>
                </b-form-group>
                <b-form-group label-align="right" :label="$t('Dinamic IP address allocation')" label-cols="4" label-cols-xl="4" label-cols-md="4">
                  <b-form-checkbox v-model="isDynamic"/>
                </b-form-group>
              </b-tab>
              <b-tab :title="$t('Hotspot allowed networks')">
                <b-row>
                  <b-col style="margin:5px">
                    <b-button variant="success" @click="swohAddNetwork">{{ $t('Add') }}</b-button>
                  </b-col>
                </b-row>
                <b-table small striped hover :items="networkItems" :fields="networkFields">
                  <template v-slot:cell(actions)="row">
                    <b-button size="sm" @click.stop="ClickOnEditNetworkButton(row)" id="transparent">
                      <b-img :src='editImage'/>
                    </b-button>
                    <b-button size="sm" @click.stop="deleteNetwork(row)" id="transparent">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </template>
                </b-table>
              </b-tab>
              <b-tab :title="$t('Prices per hour')">
                <b-row>
                  <b-col style="margin:5px">
                    <b-button variant="success" @click="swohAddTimeRange">{{ $t('Add') }}</b-button>
                  </b-col>
                </b-row>
                <b-table small striped hover :items="timeRangeItems" :fields="timeRangeFields">
                  <template v-slot:cell(actions)="row">
                    <b-button size="sm" @click.stop="ClickOnEditTimeRangeButton(row)" id="transparent">
                      <b-img :src='editImage'/>
                    </b-button>
                    <b-button size="sm" @click.stop="deleteTimeRange(row)" id="transparent">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </template>
                </b-table>
              </b-tab>
              <b-tab :title="$t('Radius parameters')">
                <b-row>
                  <b-col style="margin:5px">
                    <b-button variant="success" @click="swohAddRadiusAttr">{{ $t('Add') }}</b-button>
                  </b-col>
                </b-row>
                <b-table small striped hover :items="radiusAttrItems" :fields="radiusAttrFields">
                  <template v-slot:cell(actions)="row">
                    <b-button size="sm" @click.stop="ClickOnEditRadiusAttrButton(row)" id="transparent">
                      <b-img :src='editImage'/>
                    </b-button>
                    <b-button size="sm" @click.stop="deleteRadiusAttr(row)" id="transparent">
                      <b-img :src='deleteImage'/>
                    </b-button>
                  </template>
                </b-table>
              </b-tab>
          </b-tabs>
      </b-card>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveHotspotService">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalServices">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>

      <b-modal hide-footer :title="$t('Time range')" ref="modalTimeRange">
        <b-form-group label-align="right" :label="$t('Time range')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select :options="timeRangeList" v-model="selectTimeRange" :disabled="isEditTimeRange"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Cost per hour')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="newTimeRange.cost"/>
        </b-form-group>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveTimeRange">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideModalTimeRange">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal hide-footer :title="$t('Hotspot allowed networks')" ref="modalNetwork">
        <b-form-group label-align="right" :label="$t('Network')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newNetwork.network" placeholder="0.0.0.0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Mask')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="newNetwork.mask" placeholder="255.255.255.255"/>
        </b-form-group>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveNetwork">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideAddNetwork">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </b-modal>

      <b-modal hide-footer :title="$t('Radius parameters')" ref="modalRadiusAttr" size="lg">
        <FormRadiusAttributs
        @hideAddRadiusAttr="hideAddRadiusAttr"
        :isEditRadiusAttr="isEditRadiusAttr"
        :rowRadiusAttr="rowRadiusAttr"
        :radiusAttrItems="radiusAttrItems"/>
      </b-modal>
    </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormRadiusAttributs from '@/pages/tariffication/servicesAndTariffs/formRadiusAttributs'

export default {
  components: {
    FormRadiusAttributs
  },
  props: {
    isTariffs: null,
    isTemplates: null,
    isEdit: null,
    isTariffPlan: null,
    currentRowService: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      radiusAttr: {
        'set_object_id': 0,
        'set_type': 4,
        'attrs': []
      },
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      networkItems: [],
      networkFields: [
        {key: 'network', label: this.$i18n.t('Network'), sortable: true},
        {key: 'mask', label: this.$i18n.t('Mask'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      timeRangeItems: [],
      timeRangeFields: [
        {key: 'timerange_id', label: this.$i18n.t('Time range ID'), sortable: true},
        {key: 'time_range_name', label: this.$i18n.t('Time range name'), sortable: true},
        {key: 'cost', label: this.$i18n.t('Cost per hour'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      radiusAttrItems: [],
      radiusAttrFields: [
        {key: 'vendor', label: this.$i18n.t('Vendor'), sortable: true},
        {key: 'code', label: this.$i18n.t('Attribute'), sortable: true},
        {key: 'value', label: this.$i18n.t('Value'), sortable: true},
        {key: 'attrType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      newTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'timerange_id': 0
      },
      empertyTimeRange: {
        'cost': 0,
        'time_range_name': '',
        'timerange_id': 0
      },
      newNetwork: {
        'network': '',
        'mask': '',
        'maskDec': 0
      },
      empertyNetwork: {
        'network': '',
        'mask': '',
        'maskDec': 0
      },
      rowNetwork: null,
      rowRadiusAttr: null,
      rowTimeRange: null,
      isEditNetwork: false,
      isEditRadiusAttr: false,
      isEditTimeRange: false,
      isDynamic: false,
      serviseCost: 0,
      serviceName: '',
      validationCost: true,
      validationName: false,
      selectTimeRange: 0,
      timeRangeList: [],
      selectSupplier: 0,
      suppliertList: [],
      selectContract: 0,
      contractList: [],
      selectPolicy: 0,
      policyList: [],
      selectChargeMethod: 1,
      chargeMethodList: [
        {text: this.$i18n.t('At the start of the period'), value: 1},
        {text: this.$i18n.t('At the end of the period'), value: 2},
        {text: this.$i18n.t('Flow method'), value: 3}
      ],
      editHotspotServices: null,
      hotspotService: {
        'hotspot_service_data': {
          'recv_cost': 0,
          'rate_limit': '',
          'costs': []
        },
        'periodic_service_data': {
          'charge_method': 0,
          'scheme_id': 0,
          'radius_sessions_limit': 0,
          'cost': 1
        },
        'service_data': {
          'comment': '',
          'contract_type': 0,
          'invoice_sup_id': 0,
          'is_dynamic': 0,
          'link_by_default': 0,
          'parent_id': 0,
          'service_name': '',
          'tariff_id': 0
        }
      },
      hotspotNetworks: {
        'service_id': 0,
        'allowed_net': []
      },
      editHotspotNetworks: [],
      arrMask: new Map([
        ['255.255.255.255', 32],
        ['255.255.255.254', 31],
        ['255.255.255.252', 30],
        ['255.255.255.248', 29],
        ['255.255.255.240', 28],
        ['255.255.255.224', 27],
        ['255.255.255.192', 26],
        ['255.255.255.128', 25],
        ['255.255.255.0', 24],
        ['255.255.254.0', 23],
        ['255.255.252.0', 22],
        ['255.255.248.0', 21],
        ['255.255.240.0', 20],
        ['255.255.224.0', 19],
        ['255.255.192.0', 18],
        ['255.255.128.0', 17],
        ['255.255.0.0', 16],
        ['255.254.0.0', 15],
        ['255.252.0.0', 14],
        ['255.248.0.0', 13],
        ['255.240.0.0', 12],
        ['255.224.0.0', 11],
        ['255.192.0.0', 10],
        ['255.128.0.0', 9],
        ['255.0.0.0', 8],
        ['254.0.0.0', 7],
        ['252.0.0.0', 6],
        ['248.0.0.0', 5],
        ['240.0.0.0', 4],
        ['224.0.0.0', 3],
        ['192.0.0.0', 2],
        ['128.0.0.0', 1],
        ['0.0.0.0', 0]
      ]),
      linkByDefault: false,
      multipleLinking: true
    }
  },
  methods: {
    async saveHotspotService () {
      if (!this.serviceName || !(this.serviseCost >= 0)) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name or cost fields is invalid'), 'Error')
        return
      }
      if (!this.timeRangeItems.length) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Prices per hour table is empty'), 'Error')
        return
      }
      if (this.hotspotService.periodic_service_data.radius_sessions_limit === '') {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Limit of simultaneous sessions field is invalid'), 'Error')
        return
      }

      let response
      if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
        if (this.hotspotService.service_data.parent_id === 0) this.hotspotService.service_data.parent_id = -1
        this.linkByDefault ? this.hotspotService.service_data.link_by_default = 1 : this.hotspotService.service_data.link_by_default = 0
      }
      if (this.isTariffPlan) {
        this.hotspotService.service_data.tariff_id = this.currentRowTariffPlans.id
      }
      if (this.isEdit) {
        this.hotspotService.service_data.tariff_id = this.editHotspotServices.service_data.tariff_id
      }
      this.hotspotService.service_data.service_name = this.serviceName
      this.hotspotService.periodic_service_data.cost = Number(this.serviseCost)
      this.hotspotService.periodic_service_data.charge_method = this.selectChargeMethod
      this.hotspotService.service_data.contract_type = this.selectContract
      this.hotspotService.periodic_service_data.radius_sessions_limit = Number(this.hotspotService.periodic_service_data.radius_sessions_limit)
      this.isDynamic ? this.hotspotService.service_data.is_dynamic = 1 : this.hotspotService.service_data.is_dynamic = 0
      this.hotspotNetworks.allowed_net = this.networkItems
      this.hotspotService.hotspot_service_data.costs = this.timeRangeItems
      if (this.isEdit) {
        this.hotspotService.service_data.service_id = this.editHotspotServices.service_data.service_id
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_HOTSPOT, this.hotspotService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          }
        })
      } else {
        response = await axiosInstance.post(this.$store.getters.API_TARIFFING_SERVICES_HOTSPOT, this.hotspotService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideModalServices')
            this.$emit('reload')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
            return response.data.service_id
          }
        })
      }
      if (this.isEdit) {
        this.hotspotNetworks.service_id = this.editHotspotServices.service_data.service_id
      } else {
        this.hotspotNetworks.service_id = response
      }
      axiosInstance.put(this.$store.getters.API_TARIFFING_HOTSPOT_NETWORKS, this.hotspotNetworks)
      let suppId = {
        'service_id': 0,
        'invoice_sup_id': 0
      }
      if (this.isEdit) {
        suppId.service_id = this.editHotspotServices.service_data.service_id
      } else {
        suppId.service_id = response
      }
      suppId.invoice_sup_id = this.selectSupplier
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_SUPPLIER_ID, suppId)
      let policyId = {
        'service_id': 0,
        'policy_id': 0
      }
      if (this.isEdit) {
        policyId.service_id = this.editHotspotServices.service_data.service_id
      } else {
        policyId.service_id = response
      }
      policyId.policy_id = this.selectPolicy
      axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_CHRGE_POLICY, policyId)
      if ((this.isTemplates && this.multipleLinking) || (this.isTariffPlan && this.multipleLinking)) {
        let multiLink = {
          'service_id': 0,
          'multiple_linking': 0
        }
        if (this.isEdit) {
          multiLink.service_id = this.editHotspotServices.service_data.service_id
        } else {
          multiLink.service_id = response
        }
        multiLink.multiple_linking = 1
        axiosInstance.put(this.$store.getters.API_TARIFFING_SERVICES_SET_MULTI_LINKING, multiLink)
      }
      this.radiusAttr.attrs = this.radiusAttrItems
      if (this.isEdit) {
        this.radiusAttr.set_object_id = this.currentRowService.service_id
      } else {
        this.radiusAttr.set_object_id = response
      }
      axiosInstance.put(this.$store.getters.API_TARIFFING_RADIUS_ATTRS, this.radiusAttr)
    },
    async load () {
      let contractList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CONTRACT_TYPES).then(response => { return response.data })
      let suppliertList = await axiosInstance.get(this.$store.getters.API_TARIFFING_SUPPLIER).then(response => { return response.data })
      let policyList = await axiosInstance.get(this.$store.getters.API_TARIFFING_CHARGE_POLICE).then(response => { return response.data })
      let timeRangeList = await axiosInstance.get(this.$store.getters.API_TARIFFING_TIME_RANGE).then(response => { return response.data })
      for (let i in suppliertList) {
        suppliertList[i].value = suppliertList[i].id
        suppliertList[i].text = suppliertList[i].name
      }
      this.suppliertList = suppliertList
      for (let i in contractList) {
        contractList[i].value = contractList[i].id
        contractList[i].text = contractList[i].name
      }
      this.contractList = contractList
      for (let i in policyList) {
        policyList[i].value = policyList[i].policy_id
        policyList[i].text = policyList[i].name + ' (' + policyList[i].policy_id + ')'
      }
      this.policyList = policyList
      this.selectPolicy = this.policyList.length ? this.policyList[0].policy_id : null
      for (let i in timeRangeList) {
        timeRangeList[i].value = timeRangeList[i].tr_id
        timeRangeList[i].text = timeRangeList[i].name + ' (' + timeRangeList[i].tr_id + ')'
      }
      this.timeRangeList = timeRangeList
      this.selectTimeRange = this.timeRangeList.length ? this.timeRangeList[0].tr_id : null
      if (this.isEdit || this.isTariffPlan) {
        this.editHotspotNetworks = await axiosInstance.get(this.$store.getters.API_TARIFFING_HOTSPOT_NETWORKS + '?service_id=' + this.currentRowService.service_id).then(response => { return response.data })
        this.editHotspotServices = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES_HOTSPOT + '?service_id=' + this.currentRowService.service_id).then(response => { return response.data })
        this.radiusAttrItems = await axiosInstance.get(this.$store.getters.API_TARIFFING_RADIUS_ATTRS + '?object_id=' + this.editHotspotServices.service_data.service_id + '&object_type=' + this.editHotspotServices.service_data.service_type).then(response => { return response.data })
        this.serviseCost = this.editHotspotServices.periodic_service_data.cost
        this.serviceName = this.editHotspotServices.service_data.service_name
        this.selectSupplier = this.editHotspotServices.service_data.invoice_sup_id
        this.selectContract = this.editHotspotServices.service_data.contract_type
        this.selectChargeMethod = this.editHotspotServices.periodic_service_data.charge_method
        this.selectPolicy = this.editHotspotServices.periodic_service_data.policy_id
        this.hotspotService.service_data.comment = this.editHotspotServices.service_data.comment
        this.timeRangeItems = this.editHotspotServices.hotspot_service_data.costs
        for (let curNetwork of this.editHotspotNetworks) {
          curNetwork.maskDec = this.arrMask.get(curNetwork.mask)
        }
        this.networkItems = JSON.parse(JSON.stringify(this.editHotspotNetworks))
        this.hotspotService.periodic_service_data.radius_sessions_limit = this.editHotspotServices.periodic_service_data.radius_sessions_limit
        if (this.editHotspotServices.service_data.is_dynamic === 1) this.isDynamic = true
        for (let i in this.radiusAttrItems) {
          this.radiusAttrItems[i].value = this.radiusAttrItems[i].attr_value
          if (this.radiusAttrItems[i].tag) {
            this.radiusAttrItems[i].value = ':' + this.radiusAttrItems[i].tag + ':' + this.radiusAttrItems[i].attr_value
          }
          switch (this.radiusAttrItems[i].attr_type) {
            case 1:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Number')
              break
            case 2:
              this.radiusAttrItems[i].attrType = this.$i18n.t('String')
              break
            case 3:
              this.radiusAttrItems[i].attrType = 'IP'
              break
            case 4:
              this.radiusAttrItems[i].attrType = this.$i18n.t('Binary')
              break
          }
        }
        if (this.isTemplates || this.isTariffs || this.isTariffPlan) {
          this.hotspotService.service_data.parent_id = this.editHotspotServices.service_data.parent_id
          if (this.editHotspotServices.service_data.link_by_default === 1) {
            this.linkByDefault = true
          } else {
            this.linkByDefault = false
          }
          if (this.editHotspotServices.service_data.multiple_linking === 1) {
            this.multipleLinking = true
          } else {
            this.multipleLinking = false
          }
        }
      }
    },
    swohAddTimeRange () {
      this.newTimeRange = JSON.parse(JSON.stringify(this.empertyTimeRange))
      this.isEditTimeRange = false
      this.$refs.modalTimeRange.show()
    },
    ClickOnEditTimeRangeButton (row) {
      this.rowTimeRange = row.item
      this.isEditTimeRange = true
      this.newTimeRange = this.rowTimeRange
      this.$refs.modalTimeRange.show()
    },
    hideModalTimeRange () {
      this.$refs.modalTimeRange.hide()
    },
    saveTimeRange () {
      if (!this.newTimeRange.cost) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid sum format'), 'Error')
        return
      }
      this.newTimeRange.cost = Number(this.newTimeRange.cost)
      if (!this.isEditTimeRange) {
        for (let i in this.timeRangeItems) {
          if (this.timeRangeItems[i].timerange_id === this.selectTimeRange) {
            this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Attempt to add one more time range for same id'), 'Error')
            return
          }
        }
        this.newTimeRange.timerange_id = this.selectTimeRange
        for (let i in this.timeRangeList) {
          if (this.timeRangeList[i].tr_index === this.selectTimeRange) {
            this.newTimeRange.time_range_name = this.timeRangeList[i].time_range.name
          }
        }
        this.timeRangeItems.push(this.newTimeRange)
      }
      this.hideModalTimeRange()
    },
    deleteTimeRange (row) {
      this.rowTimeRange = row.item
      this.timeRangeItems = this.timeRangeItems.filter((value) => {
        return value !== this.rowTimeRange
      })
    },
    swohAddRadiusAttr () {
      this.rowRadiusAttr = null
      this.isEditRadiusAttr = false
      this.$refs.modalRadiusAttr.show()
    },
    ClickOnEditRadiusAttrButton (row) {
      this.rowRadiusAttr = row.item
      this.isEditRadiusAttr = true
      this.$refs.modalRadiusAttr.show()
    },
    hideAddRadiusAttr () {
      this.$refs.modalRadiusAttr.hide()
    },
    deleteRadiusAttr (row) {
      this.rowRadiusAttr = row.item
      this.radiusAttrItems = this.radiusAttrItems.filter((value) => {
        return value !== this.rowRadiusAttr
      })
    },
    hideModalServices () {
      this.$emit('hideModalServices')
    },
    swohAddNetwork () {
      this.newNetwork = JSON.parse(JSON.stringify(this.empertyNetwork))
      this.isEditNetwork = false
      this.$refs.modalNetwork.show()
    },
    ClickOnEditNetworkButton (row) {
      this.rowNetwork = row.item
      this.newNetwork = this.rowNetwork
      this.isEditNetwork = true
      this.$refs.modalNetwork.show()
    },
    deleteNetwork (row) {
      this.rowNetwork = row.item
      this.networkItems = this.networkItems.filter((value) => {
        return value !== this.rowNetwork
      })
    },
    saveNetwork () {
      if (!this.newNetwork.network || !this.newNetwork.mask) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Invalid field ip or mask'), 'Error')
        return
      }
      if (!this.validationIP()) return
      if (!this.validationMask()) return
      this.newNetwork.maskDec = this.arrMask.get(this.newNetwork.mask)
      if (!this.isEditNetwork) {
        this.networkItems.push((this.newNetwork))
      }
      this.hideAddNetwork()
    },
    hideAddNetwork () {
      this.$refs.modalNetwork.hide()
    },
    validationIP () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      if (this.newNetwork.network.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationMask () {
      if (this.arrMask.has(this.newNetwork.mask)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect mask format'), 'Error')
        return false
      }
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    serviceName: function (val) {
      if (val.length) {
        this.validationName = true
      }
    },
    serviseCost: function (val) {
      if (val >= 0) {
        this.validationCost = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formHotspotService.vue